export const DEFAULT_FORUM_LOGO_URL = 'https://img.kitapcik.net/logoyok.png';

/** Forum yöneticisi (kartta yalnızca site yöneticisine görünür) */
export type ForumAdminContact = {
  name: string;
  profile_url: string;
};

/** Paylaşılan forum tipi */
export interface ForumBase {
  id: string;
  forum_id: string;
  name: string;
  url?: string | null;
  category: string;
  topics_count: number;
  posts_count: number;
  members_count: number;
  founded_year: number;
  description?: string | null;
  logo_url?: string | null;
  is_active?: boolean;
  is_sponsored?: boolean;
  sponsored_until?: string | null;
  software?: string | null;
  previous_month_topics_count?: number | null;
  previous_month_posts_count?: number | null;
  previous_month_members_count?: number | null;
  updated_at?: string | null;
  created_at?: string | null;
  average_rating?: number | null;
  rating_count?: number | null;
  topics_selector?: string | null;
  posts_selector?: string | null;
  members_selector?: string | null;
  scrape_login_url?: string | null;
  scrape_username?: string | null;
  scrape_password?: string | null;
  scrape_login_username_selector?: string | null;
  scrape_login_password_selector?: string | null;
  scrape_login_submit_selector?: string | null;
  /** Forumdaki tanıtım bölümü URL (yalnızca site yöneticisi UI) */
  promo_section_url?: string | null;
  /** Birden fazla forum yöneticisi (yalnızca site yöneticisi UI) */
  forum_admins?: ForumAdminContact[] | null;
  /** Kontrol eden(ler) — yalnızca site yöneticisi UI */
  forum_controllers?: ForumAdminContact[] | null;
  /** @deprecated forum_admins kullanın */
  forum_admin_name?: string | null;
  /** @deprecated forum_admins kullanın */
  forum_admin_profile_url?: string | null;
  city?: string | null;
  country?: string | null;
  is_verified?: boolean;
  verified_at?: string | null;
  wayback_url?: string | null;
  closure_date?: string | null;
  http_last_ok?: boolean;
  tags?: string[];
}

export type GrowthMetric = 'members' | 'posts' | 'topics' | 'score';
